import React from 'react'
import PatternsTable from './PatternsTable'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'
import { useSelector } from 'react-redux'

const PatternsSection = () => {
    const assignmentName = useSelector(state => state.assignment.assignment_name)
    useDocumentTitle(`${assignmentName || ''} Patterns`)

    return <PatternsTable />
}

export default PatternsSection
